import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

const HEAD_WIDTHS = ['xl:w-[17%]', 'w-[26%] xl:w-[14%]', 'w-[22%] xl:w-[14%]', 'w-[12%] xl:w-[8%]', 'max-xl:hidden', 'w-[8%] max-xl:hidden', 'w-[16%] max-xl:hidden'];

/** One skeleton row: the cell class and the bar size of each of the seven columns. */
const ROW_CELLS: Array<{ cell: string; bar: string }> = [
  { cell: 'py-3', bar: 'h-3.5 w-32' },
  { cell: 'py-3', bar: 'h-5 w-24' },
  { cell: 'py-3', bar: 'h-5 w-24' },
  { cell: 'py-3', bar: 'h-3 w-14' },
  { cell: 'py-3 max-xl:hidden', bar: 'h-3 w-48' },
  { cell: 'py-3 max-xl:hidden', bar: 'h-3 w-12' },
  { cell: 'py-3 max-xl:hidden', bar: 'h-3 w-28' },
];

export function TableSkeleton() {
  return (
    <Table aria-busy="true" aria-label="Loading builds" className="table-fixed">
      <TableHeader>
        <TableRow className="hover:bg-transparent">
          {HEAD_WIDTHS.map((w, i) => (
            <TableHead key={i} className={w}>
              <Skeleton className="h-3 w-14" />
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {[0, 1, 2, 3, 4].map((i) => (
          <SkeletonRow key={i} />
        ))}
      </TableBody>
    </Table>
  );
}

function SkeletonRow() {
  return (
    <TableRow className="hover:bg-transparent">
      {ROW_CELLS.map((c, i) => (
        <TableCell key={i} className={c.cell}>
          <Skeleton className={c.bar} />
        </TableCell>
      ))}
    </TableRow>
  );
}

export function CardsSkeleton() {
  return (
    <div className="flex flex-col gap-3 p-4" aria-busy="true" aria-label="Loading builds">
      {[0, 1, 2].map((i) => (
        <Card key={i} className="gap-3 p-4 shadow-none">
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-36" />
            <Skeleton className="h-5 w-20" />
          </div>
          <Skeleton className="h-3 w-40" />
          <div className="flex gap-2">
            <Skeleton className="h-5 w-16" />
            <Skeleton className="h-5 w-24" />
          </div>
          <Skeleton className="h-3 w-full" />
        </Card>
      ))}
    </div>
  );
}
